<template>
  <el-header class="mes-navbar">
    <div class="mes-navbar__trigger" @click="handleToggleSidebar">
      <i v-if="!open || device === 'mobile'" class="el-icon-s-unfold"></i>
      <i v-else class="el-icon-s-fold"></i>
    </div>
    <div class="mes-navbar__trigger" @click="handleReload">
      <i class="el-icon-refresh-right"></i>
    </div>
    <mes-breadcrumb />
    <div class="mes-navbar__right">
      <router-link to="/home" custom v-slot="{ navigate }">
        <div class="mes-navbar__trigger" @click="navigate">{{ $t('proscenium')}}</div>
      </router-link>
      <el-dropdown trigger="click" @command="handleCommand">
        <div class="mes-navbar__trigger">
          <span class="el-dropdown-link">
            {{ user.userName }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="logout">{{$t('outlogin')}}</el-dropdown-item>
          <el-dropdown-item command="updatePwd">{{$t('updatePwd')}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown trigger="click" @command="handleCommand">
         <span class="el-dropdown-link">
           {{ $t('language') }}<i class="el-icon-arrow-down el-icon--right"></i>
         </span>
         <el-dropdown-menu>
           <el-dropdown-item command="Chinese">
               中文
          </el-dropdown-item>
           <el-dropdown-item command="English">
               English
          </el-dropdown-item>
         </el-dropdown-menu>
      </el-dropdown>
    </div>
    <my-Dialog
      v-if="visible"
      :title="$t('updatePwd')"
      width="620px"
      :show.sync="visible"
      :loading="btnLoading"
      @confirm="handleSave">
      <custom-add
        :id="id"
        ref="CustomAdd"
        :loading.sync="btnLoading"
        @close="handleClose"
      />
    </my-Dialog>
  </el-header>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import Vue from 'vue';
import MesBreadcrumb from '../breadcrumb';
import { mapGetters } from 'vuex';
import Cookie from '@/utils/cookie';
import myDialog from '@/components/dialog';
import CustomAdd from '@/views/system/user/updatePwd';
import { addMixin } from '@/mixins';
export default {
  name: 'Navbar',
  components: {
    MesBreadcrumb,
    myDialog,
    CustomAdd
  },
  computed: {
    ...mapGetters([
      'user',
      'open',
      'device'
    ])
  },
  mixins: [
    addMixin
  ],
  methods: {
    // 切换侧边栏
    handleToggleSidebar() {
      this.$store.dispatch('toggleSidebar');
    },
    // 刷新
    handleReload() {
      const { fullPath } = this.$route;
      this.$router.replace({
        path: '/redirect' + fullPath
      });
    },
    // 菜单项触发的事件回调
    async handleCommand(command) {
      switch (command) {
        case 'logout':
          await this.$store.dispatch('resetToken');
          this.$message.success(this.$t('outok'));
          if (this.$keycloak && this.$keycloak.authenticated) {
            this.$keycloak.logoutFn();
          } else {
            this.$router.replace({
              path: '/home/login',
              query: {
                redirect: this.$route.fullPath
              }
            });
          }
          break;
        case 'Chinese':
          this.$i18n.locale = 'zh';
          Cookie.set('lanConfig', 'zh', 30);
          location.reload();
          break;
        case 'English':
          this.$i18n.locale = 'en';
          Cookie.set('lanConfig', 'en', 30);
          location.reload();
          break;
        case 'updatePwd':
          this.handleAdd();
          break;
      }
    }
  }
};
</script>

<style lang="scss">
@include b(navbar) {
  padding-left: 0;
  line-height: $header-height-base;
  box-shadow: $box-shadow-light;
  .el-dropdown {
    height: 42px;
  }
  @include e(trigger) {
    display: inline-block;
    height: $header-height-base;
    padding: $header-padding-primary;
    text-align: center;
    cursor: pointer;
    transition: all .2s ease-in-out;
    [class^=el-icon-] {
      font-size: $font-size-large;
      color: $color-text-light;
    }
    &:hover {
      background: $background-color-base;
    }
  }
  @include e(right) {
    float: right;
    height: $header-height-base;
  }
}
</style>